export class ErrorConstants {
  static readonly CENTRAL_INVALID_REFRESH_TOKEN = 'CENTRAL_INVALID_REFRESH_TOKEN';
  static readonly CENTRAL_INVALID_EMAIL_VERIFICATION_TOKEN_MESSAGE =
    'Unable to verify token: Verify new username token has expired';
}
